import { render, staticRenderFns } from "./combo-setting.vue?vue&type=template&id=15949800&scoped=true"
import script from "./combo-setting.vue?vue&type=script&lang=js"
export * from "./combo-setting.vue?vue&type=script&lang=js"
import style0 from "./combo-setting.vue?vue&type=style&index=0&id=15949800&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15949800",
  null
  
)

export default component.exports